<script setup lang="ts">
import { useAppStore } from '@/store';
import { useSignStore } from '@/modules/sign/store';
import { useMyPageStore } from '@/store/myPageStore';
import Cookies from 'js-cookie';
import { REFRESH_TOKEN_KEY } from './modules/sign/constants';
const signStore = useSignStore();
const appStore = useAppStore();
const myPageStore = useMyPageStore();

function handleResize() {
  appStore.updateIsMobile();
}

onMounted(async () => {
  await signStore.getAccessToken();
  if (Cookies.get(REFRESH_TOKEN_KEY)) {
    await myPageStore.initializePositionList();
    await myPageStore.updateMyInfo();
  }
  window.addEventListener('resize', handleResize);
  handleResize(); // 초기화
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<template>
  <RouterView></RouterView>
</template>

<style></style>
